interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Figma "Dashboard" nav-tab icon (bento grid of rounded blocks). */
const FigmaDashboardIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 120 120'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M78.001 78.0001C71.3734 78.0001 66.001 83.3725 66.001 90.0001V108C66.001 114.628 71.3734 120 78.001 120H78.145C85.6636 120 92.1154 119.605 97.5058 118.407C102.965 117.194 107.697 115.079 111.389 111.388C115.08 107.697 117.195 102.964 118.408 97.5049C118.958 95.0293 119.321 92.5165 119.559 89.9875C120.182 83.3893 114.629 78.0001 108.001 78.0001H78.001Z'
        fill={color}
      />
      <path
        d='M0 78.144V66C0 59.3724 5.37258 54 12 54H42C48.6276 54 54 59.3724 54 66V108C54 114.628 48.6276 120 42 120H41.856C34.3372 120 27.8857 119.605 22.4949 118.407C17.036 117.194 12.3039 115.079 8.61258 111.388C4.92126 107.696 2.80632 102.964 1.59312 97.5048C0.395041 92.1144 0 85.6626 0 78.144Z'
        fill={color}
      />
      <path
        d='M120.001 54C120.001 60.6276 114.629 66 108.001 66H78.001C71.3734 66 66.001 60.6276 66.001 54V12C66.001 5.37258 71.3734 0 78.001 0H78.145C85.6636 0 92.1154 0.395041 97.5058 1.59312C102.965 2.80632 107.697 4.92126 111.389 8.61258C115.08 12.3039 117.195 17.036 118.408 22.4949C119.606 27.8857 120.001 34.3372 120.001 41.856V54Z'
        fill={color}
      />
      <path
        d='M54.0025 12C54.0025 5.37258 48.6301 0 42.0025 0H41.8585C34.3397 0 27.8882 0.395041 22.4974 1.59312C17.0385 2.80632 12.3064 4.92126 8.61511 8.61258C4.92379 12.3039 2.80885 17.036 1.59565 22.4949C1.04539 24.9708 0.682267 27.4838 0.443887 30.0126C-0.178012 36.6108 5.37511 42 12.0025 42H42.0025C48.6301 42 54.0025 36.6274 54.0025 30V12Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaDashboardIcon;
